import { RootState } from "../store/store";

export const selectAccountVerificationData = (state: RootState) =>
  state.accountVerification.accountVerificationData;

export const selectAccountVerificationIsLoading = (state: RootState) =>
  state.accountVerification.isLoading;

export const selectAccountVerificationError = (state: RootState) =>
  state.accountVerification.error;

export const selectIdentityClientSecret = (state: RootState) =>
  state.accountVerification?.identitySession?.clientSecret ?? null;

export const selectIdentityIsLoading = (state: RootState) =>
  state.accountVerification?.identitySession?.isLoading ?? null;

export const selectIdentityError = (state: RootState) =>
  state.accountVerification?.identitySession?.error ?? null;

export const selectIdentitySessionUrl = (state: RootState) =>
  state.accountVerification.identitySession.sessionUrl;

export const selectIdentityIsProcessing = (state: RootState) =>
  state.accountVerification?.identitySession?.processing ?? false;

export const selectIdentityAlreadyVerified = (state: RootState) =>
  state.accountVerification?.identitySession?.alreadyVerified ?? false;

export const selectAccountLink = (state: RootState) =>
  state.accountVerification.accountLink;

export const selectAccountRequirements = (state: RootState) =>
  state.accountVerification.requirements;

export const selectAccountDetails = (state: RootState) =>
  state.accountVerification.detailState;
